"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_localization_1 = require("@sport-thieme/util-localization");
var moment_1 = __importDefault(require("moment"));
var fiscalYearRange_1 = require("./fiscalYearRange");
function defaultDateRangePickerSuggestions(rangeSuggestions, showDefaultRangeSuggestions) {
    return function () {
        if (rangeSuggestions.length || showDefaultRangeSuggestions === false)
            return rangeSuggestions;
        return [
            {
                label: util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Today"], ["Today"]))),
                range: {
                    start: moment_1.default().startOf('day').toDate(),
                    end: moment_1.default().endOf('day').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Yesterday"], ["Yesterday"]))),
                range: {
                    start: moment_1.default().subtract(1, 'day').startOf('day').toDate(),
                    end: moment_1.default().subtract(1, 'day').endOf('day').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Last week"], ["Last week"]))),
                range: {
                    start: moment_1.default().subtract(1, 'week').startOf('week').toDate(),
                    end: moment_1.default().subtract(1, 'week').endOf('week').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_4 || (templateObject_4 = __makeTemplateObject(["Last month"], ["Last month"]))),
                range: {
                    start: moment_1.default().subtract(1, 'month').startOf('month').toDate(),
                    end: moment_1.default().subtract(1, 'month').endOf('month').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_5 || (templateObject_5 = __makeTemplateObject(["Last ", " days"], ["Last ", " days"])), '7'),
                range: {
                    start: moment_1.default().subtract(6, 'days').startOf('day').toDate(),
                    end: moment_1.default().endOf('day').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_6 || (templateObject_6 = __makeTemplateObject(["Last ", " days"], ["Last ", " days"])), '30'),
                range: {
                    start: moment_1.default().subtract(29, 'days').startOf('day').toDate(),
                    end: moment_1.default().endOf('day').toDate(),
                },
            },
            {
                label: util_localization_1.localize(templateObject_7 || (templateObject_7 = __makeTemplateObject(["This fiscal year"], ["This fiscal year"]))),
                range: fiscalYearRange_1.fiscalYearRange(),
            },
            {
                label: util_localization_1.localize(templateObject_8 || (templateObject_8 = __makeTemplateObject(["Last fiscal year"], ["Last fiscal year"]))),
                range: fiscalYearRange_1.lastFiscalYearRange(),
            },
        ];
    };
}
exports.default = defaultDateRangePickerSuggestions;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=defaultDateRangePickerSuggestions.js.map